import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { auth } from "../../firebase";
import { setAuthError } from "../slices/authSlice";

export const signIn = (credentials) => {
  return async (dispatch) => {
    try {
      await signInWithEmailAndPassword(
        auth,
        credentials.email,
        credentials.password
      );
      // setAuth and setProfile are handled by AuthListener in index.js
    } catch (err) {
      dispatch(setAuthError(err.message));
    }
  };
};

export const signout = () => {
  return async (dispatch) => {
    try {
      await signOut(auth);
    } catch (err) {
      console.error("Logout error", err);
    }
  };
};
